import type { Config } from "tailwindcss";

import baseConfig from "@alaffia-technology-solutions/tailwind-config/base";

import { antdTokens } from "./tailwind-antd-tokens";

export default {
  presets: [baseConfig],
  content: [
    "../../node_modules/@alaffia-technology-solutions/ds/dist/**/*.js",
    "../../packages/auth/**/*.{ts,tsx}",
    "../../packages/components/**/*.{ts,tsx}",
    "../../packages/features/**/*.{ts,tsx}",
    "../../packages/pdf-viewer/**/*.{ts,tsx}",
    "../../packages/ds/src/**/*.{ts,tsx}",
    "./src/**/*.{html,js,ts,jsx,tsx}",
  ],
  corePlugins: {
    preflight: true,
  },
  theme: {
    extend: {
      colors: {
        ...antdTokens.colors,
      },
      antd: {
        dark: {
          ...antdTokens.tokens.dark.colors,
          ...antdTokens.tokens.dark.tokens,
        },
        light: {
          ...antdTokens.tokens.light.colors,
          ...antdTokens.tokens.light.tokens,
        },
      },
      gridTemplateColumns: {
        24: "repeat(24, minmax(0, 1fr))",
      },
      gridColumnStart: {
        13: "13",
        14: "14",
        15: "15",
        16: "16",
        17: "17",
        18: "18",
        19: "19",
        20: "20",
        21: "21",
        22: "22",
        23: "23",
        24: "24",
      },
      gridColumnEnd: {
        13: "13",
        14: "14",
        15: "15",
        16: "16",
        17: "17",
        18: "18",
        19: "19",
        20: "20",
        21: "21",
        22: "22",
        23: "23",
        24: "24",
      },
    },
  },
} satisfies Config;
